var map = {
	"./bg.json": "3565",
	"./bn.json": "1fe4",
	"./cs.json": "4aaa",
	"./da.json": "e730",
	"./de.json": "0950",
	"./el.json": "1825",
	"./en.json": "0262",
	"./es.json": "2359b",
	"./fi.json": "8fac",
	"./fr.json": "7960",
	"./hi.json": "2cd6",
	"./hr.json": "4128",
	"./hu.json": "1f1d",
	"./id.json": "92d6",
	"./it.json": "1632",
	"./ja.json": "08e5",
	"./ko.json": "4d4c",
	"./ms.json": "49f6",
	"./nl.json": "f652",
	"./no.json": "fe59",
	"./pl.json": "8d07",
	"./pt.json": "4773",
	"./ro.json": "c994",
	"./ru.json": "cd7c",
	"./sk.json": "9ed8",
	"./sl.json": "d8ea",
	"./th.json": "0cbc",
	"./tr.json": "b091",
	"./uk.json": "07fe",
	"./vi.json": "e2c1",
	"./zh.json": "36af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32ea";